import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import React from "react";
import { Col, Row } from "react-bootstrap";
const BottomInputMsg = (props) => {
    return (React.createElement(React.Fragment, null,
        React.createElement(Row, null, !props.showlink ? (React.createElement(Col, { lg: 12, className: props.parentClass },
            React.createElement("span", { className: "DMSansNormal_12_400 txt_primaryGrey" }, props.message))) : (React.createElement(Col, { lg: 12 },
            React.createElement(EdButton, { btnTyp: "midnight-blue-underline", type: "button", className: "DMSansNormal_12_400", value: props.message, onClick: () => {
                    props.callBackFunction ? props.callBackFunction() : () => { };
                } }))))));
};
export default BottomInputMsg;
